import { Button, Flex } from "@mantine/core"
import { isNotEmpty, useForm, UseFormReturnType } from "@mantine/form"
import CityDropdown from "common/dropdown/city"
import ProvinceDropdown from "common/dropdown/province"
import CheveronDownIcon from "common/icons/cheveron-down"
import { FC } from "react"
import IProjectCreate from "rules/interface/project/create.interface"




interface IProps {
    form: UseFormReturnType<IProjectCreate>
    nextStep: () => void
}


const PriceFormStepLocation: FC<IProps> = ({ form: projectForm, nextStep }) => {

    const form = useForm<IProjectCreate>({
        initialValues: {
            ...(projectForm.values.province && {
                province: projectForm.values.province,
                provinceId: projectForm.values.province?._id,
            }),
            ...(projectForm.values.city && {
                city: projectForm.values.city,
                cityId: projectForm.values.city?._id,
            }),
        },
        validate: {
            provinceId: value => !value && "استان نمیتواند خالی باشد",
            cityId: value => !value && "شهر نمیتواند خالی باشد",
        },
    })

    const onSubmit = (values: IProjectCreate) => {
        projectForm.setValues({
            province: values.province,
            city: values.city,
        })

        nextStep()
    }



    return (
        <form
            onSubmit={form.onSubmit(
                values => onSubmit(values),
                errors => {
                    const firstErrorPath = Object.keys(errors)[0];
                    form.getInputNode(firstErrorPath)?.focus();
                },
            )}
            className="w100"
        >
            <Flex
                direction="column"
                gap={32}
                w="100%"
            >
                <Flex
                    direction="column"
                    gap={8}
                >
                    <ProvinceDropdown
                        label="استان"
                        onChangeObject={value => form.setValues({
                            province: value,
                            city: undefined,
                            cityId: undefined
                        })}
                        {...form.getInputProps("provinceId")}
                        placeholder="انتخاب کنید ..."
                        containerProps={{
                            style: {
                                width: "100%",
                                maxWidth: "385px",
                            }
                        }}
                        styles={{
                            input: {
                                background: "#F9F9F9",
                                border: "none"
                            }
                        }}
                    />

                    <CityDropdown
                        onChangeObject={value => form.setValues({
                            city: value,
                        })}
                        {...form.getInputProps("cityId")}
                        label="شهر"
                        enabled={Boolean(form.values.provinceId)}
                        placeholder={!form.values.provinceId ? "ابتدا استان را انتخاب کنید" : "انتخاب کنید ..."}
                        province={form.values.provinceId}
                        containerProps={{
                            style: {
                                width: "100%",
                                maxWidth: "385px"
                            }
                        }}
                        styles={{
                            input: {
                                background: "#F9F9F9",
                                border: "none"
                            }
                        }}
                    />
                </Flex>

                <Button
                    rightSection={
                        <CheveronDownIcon
                            style={{ transform: "rotate(90deg)" }}
                            color="#fff"
                        />
                    }
                    type="submit"
                >
                    مرحله بعدی
                </Button>
            </Flex>
        </form>
    )
}

export default PriceFormStepLocation